import React, { useState } from 'react';
import { useUserStore } from 'store/user';
import { authConstants } from 'utils/constants/auth';
import { locationHelpers } from 'utils/helpers/locationHelpers';

import PageLoader from 'components/ui/PageLoader/PageLoader';
import { useOnce } from 'components/utils/hooks/useOnce';

interface IProtectedPage {
    children: JSX.Element;
}

export const ProtectedPage: React.FC<IProtectedPage> = (props) => {
    const { children } = props;

    const isLoading = useUserStore('isLoading');
    const getUserInfo = useUserStore('getUserInfo');

    const [view, setIsView] = useState(false);

    useOnce(
        () => true,
        async () => {
            try {
                const user = await getUserInfo();

                if (!user.authorized) {
                    return locationHelpers.replaceLocation(
                        authConstants.REDIRECT_URL,
                    );
                }

                return setIsView(true);
            } catch (error) {
                console.error('Failed to load user info', error);

                return locationHelpers.replaceLocation(
                    authConstants.REDIRECT_URL,
                );
            }
        },
        [],
    );

    if (!view || isLoading) {
        return <PageLoader />;
    }

    return children;
};
